import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createPaymentMethod } from '../../api/payment-method.ts';
import { CreatePaymentMethodRequest } from '../../api/requests/payment-method-request.ts';

export default function useCreatePaymentMethod(): UseMutationResult<
  Awaited<ReturnType<typeof createPaymentMethod>>,
  Error,
  CreatePaymentMethodRequest
> {
  return useMutation({
    mutationFn: createPaymentMethod,
  });
}
